/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';

import { useTranslation, Trans } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { onboardinErrorObject } from '@constants/errorObjects';

import { showError } from '@store/common/actions';
import useBreakpoint from '@hooks/breakpoint';
import * as ROUTES from '@constants/routes';
import { isCountryPeru, isCountryColombia } from '@constants/regions';
import useQuery from '@hooks/useQuery';
import { LoginHeader, Header, Spinner, RePasswordForm } from '@components';
import { validateTokenByProfileId, createPasswordAndes } from '@services/onboarding-service';

const showCheckPrivacyPolicy = isCountryColombia;
const showPolicies = isCountryPeru;

const Container = styled.div`
  ${({ theme }) => theme.breakpoint('sm', 'md')} {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
`;

const CreatePasswordAndes = () => {
  const [ready, setReady] = useState(false);
  const [errorEndpoint, setErrorEndpoint] = useState(false);
  const { mobile } = useBreakpoint();
  const token = useQuery().get('t');
  const viewTyc = useQuery().get('c');
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  if (!token) {
    history.push(ROUTES.LOGIN);
  }

  const validateToken = async () => {
    try {
      await validateTokenByProfileId({
        id: token,
      });
      setReady(true);
    } catch (error) {
      dispatch(showError(onboardinErrorObject(error)));
      history.push(ROUTES.LOGIN);
    }
  };

  const handleSubmit = async (password) => {
    try {
      await createPasswordAndes({
        password,
        id: token,
      });
      history.push(ROUTES.ACCOUNT_CREATED);
    } catch (error) {
      const customMessage =
        error.message.message === 'Password invalid'
          ? t('passwordForms.errorForPassword')
          : t('passwordForms.errorForService');
      setReady(true);
      dispatch(showError(onboardinErrorObject({ message: customMessage })));
      if (error.message.message === 'Password invalid') {
        setErrorEndpoint(true);
      } else {
        setErrorEndpoint(false);
      }
    }
  };

  useEffect(() => {
    validateToken();
    setReady(true);
  }, []);

  const initialState = {
    clickedSecondInput: false,
  };

  const [state, setState] = useState(initialState);

  const handleSecondInputClick = () => {
    setState({ ...state, clickedSecondInput: true });
  };

  const handleFirstInputClick = () => {
    setErrorEndpoint(false);
    setState({ ...state, clickedSecondInput: false });
  };

  return (
    <>
      {ready ? (
        <Container>
          {mobile ? <Header withoutTextMobile isResetPass /> : <LoginHeader isResetPass />}
          <>
            <RePasswordForm
              title={t('passwordForms.titleCreatePassword')}
              subtitle={<Trans i18nKey="passwordForms.subtitleTitleChangePassword" />}
              handleSubmit={handleSubmit}
              errorEndpoint={errorEndpoint}
              handleFirstInputClick={handleFirstInputClick}
              handleSecondInputClick={handleSecondInputClick}
              state={state}
              showCheckPrivacyPolicy={showCheckPrivacyPolicy}
              viewTyc={viewTyc === null}
              showPolicies={showPolicies}
              isCreate
            />
          </>
        </Container>
      ) : (
        <Spinner aligned />
      )}
    </>
  );
};

export default CreatePasswordAndes;
